export const TransactionTypeMap: Record<string, string> = {
  "0": "Other",
  "1": "Sale",
  "2": "Void",
  "3": "Refund",
  "5": "Adjustment",
  "9": "UnRefund",
  "10": "Unvoid",
  "21": "ACM",
};